import { type FC } from "react";
import { SidebarGroup, SidebarGroupContent, SidebarMenu, SidebarMenuItem } from "@capacit-com/lara-law-shared-ui";
import {  } from "@capacit-com/lara-law-shared-ui";
import { Skeleton } from "@capacit-com/lara-law-shared-ui";

export const ChatReferencesTabSkeleton: FC = () => {
  return (
    <SidebarGroup>
      <SidebarGroupContent>
        <SidebarMenu>
          {Array.from({ length: 5 }).map((_, index) => (
            <SidebarMenuItem key={index}>
              <div className="flex justify-between w-full items-center px-2 py-2">
                <div className="flex flex-col w-0 flex-1 gap-2">
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-3 w-3/4" />
                </div>
                <Skeleton className="size-4 ml-2 shrink-0" />
              </div>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};

export const VersionHistoryTabSkeleton: FC = () => {
  return (
    <div className="flex flex-col h-full">
      <div className="mb-2 px-2">
        <Skeleton className="h-6 w-40 mb-2" />
        <Skeleton className="h-4 w-32" />
      </div>
      <div className="flex flex-col gap-3 px-2 py-2 overflow-y-auto">
        {Array.from({ length: 4 }).map((_, index) => (
          <div
            key={index}
            className="flex flex-col gap-2 p-3 border rounded-md"
          >
            <div className="flex justify-between items-start">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-5 w-16" />
            </div>
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-3 w-2/3" />
          </div>
        ))}
      </div>
    </div>
  );
};

export const DocumentReferencesTabSkeleton: FC = () => {
  return (
    <SidebarGroup>
      <SidebarGroupContent>
        <SidebarMenu>
          {Array.from({ length: 5 }).map((_, index) => (
            <SidebarMenuItem key={index}>
              <div className="flex justify-between w-full items-center px-2 py-2">
                <div className="flex flex-col w-0 flex-1 gap-2">
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-3 w-3/4" />
                </div>
                <Skeleton className="size-4 ml-2 shrink-0" />
              </div>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};

export const DocumentMetadataTabSkeleton: FC = () => {
  return (
    <SidebarGroup>
      <SidebarGroupContent className="px-2 py-2">
        <Skeleton className="h-5 w-24 mb-4" />
        <div className="flex flex-col gap-4">
          <div>
            <Skeleton className="h-4 w-20 mb-2" />
            <Skeleton className="h-16 w-full" />
          </div>
          {Array.from({ length: 5 }).map((_, index) => (
            <div key={index}>
              <Skeleton className="h-3 w-24 mb-1" />
              <Skeleton className="h-4 w-full" />
            </div>
          ))}
        </div>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};

export const TableOfContentsTabSkeleton: FC = () => {
  return (
    <SidebarGroup>
      <SidebarGroupContent>
        <Skeleton className="h-5 w-24 mb-4" />
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
